import controller from './mail-viewer-attachment.controller';
import template from './mail-viewer-attachment.html';
import './mail-viewer-attachment.scss';

export default {
	template,
	bindings: {
		attachment: '<ngModel',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
